const $ = jQuery.noConflict();

'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	strCF7Holder: '.js-cf7-holder',
	strForm: '.wpcf7-form',
	strTriggerURL: '#wpcf7-f17-o1',
	classSent: 'form-is-sent',
	classInvalid: 'invalid',

	/** @description Initialize */
	init: function() {
		this.checkIfIE();
		this.afterFormSubmit();
		this.rangeSlider();
		this.preventNumberInputScroll();
		this.disableCF7MultipleRequests();
		this.preventNumTelInputsTypeLetters();
		this.handleConditionalFields();
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 5000) => {
		document.addEventListener('wpcf7mailsent', (e) => {
			const formId = e.detail.unitTag;
			const formElement = document.querySelector(`#${formId}`);

			if (formElement) {
				const formParent = formElement.closest(formHolder);
				if (formParent) {
					formParent.classList.add(sentClass);

					setTimeout(() => {
						formParent.classList.remove(sentClass);
					}, delay);
				}
			}

			// Re-run conditional logic after reset
			setTimeout(() => {
				FormHelpers.handleConditionalFields();
			}, 50);

			// const selectElement = document.querySelector('.js-select');

			// if (selectElement) {
			// 	// Reset Select2 to initial value (placeholder)
			// 	$(selectElement).val(null).trigger('change');
			// }
		}, false);
	},

	disableCF7MultipleRequests: ()=> {
		$('form.wpcf7-form').on('submit', function() {
			const form = $(this);
			const button = form.find('input[type=submit]');
			const currentVal = button.val();
			// store the current value so we can reset it later
			button.attr('data-value', currentVal);
			// disable the button
			button.prop('disabled', true);

		});
		$('.wpcf7').on('wpcf7invalid', function() {
			$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);
		});
		$('.wpcf7').on('wpcf7mailsent', function() {
			$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);
		});
	},

	// If user use Internet Explorer this is custom trigger for Thank you msg for CF7
	checkIfIE() {
		const url = window.location.href;
		if (url.indexOf(FormHelpers.strTriggerURL) > -1 && !$(FormHelpers.strForm).hasClass(FormHelpers.classInvalid)) {
			$(FormHelpers.strForm).parents(FormHelpers.strCF7Holder).addClass(FormHelpers.classSent);

			setTimeout(() => {
				$(FormHelpers.strCF7Holder).removeClass(FormHelpers.classSent);
			}, 5000);
		}
	},

	rangeSlider() {
		const elRangeInputs = document.querySelectorAll('.range');

		function setProgress(elTarget) {
			const elRangeBar = elTarget.parentElement;
			const intThumbWidth = elRangeBar.clientHeight * 3;
			const intRangeBarWidth = elRangeBar.clientWidth - intThumbWidth;
			const intThumbWidthOffset = intThumbWidth / 2;
			const intProgressPosition = (elTarget.value - elTarget.min) / (elTarget.max - elTarget.min);
			const intRangePosition = (intRangeBarWidth * intProgressPosition) + intThumbWidthOffset;

			elRangeBar.style.background =
				'linear-gradient(to right, #5c92ff ' +
				intRangePosition + 'px, #e2e2ea ' +
				intRangePosition + 'px';
		}

		for (let i = 0; i < elRangeInputs.length; i++) {
			elRangeInputs[i].firstElementChild.addEventListener('input', function() {
				setProgress(this);
			});
			setProgress(elRangeInputs[i].firstElementChild);
		}
	},

	/**
	 * @description Prevent number input scroll using mouse wheel or keyboard arrows
	 */
	preventNumberInputScroll: function() {
		const numberInputs = document.querySelectorAll('input[type="number"]');

		numberInputs.forEach((input) => {
			// Prevent mouse wheel from changing input value
			input.addEventListener('wheel', function(e) {
				e.preventDefault();
			});
		});
	},

	preventNumTelInputsTypeLetters: function() {
		$('input[type="number"]').on('input', function() {
			const nonNumReg = /[^0-9]/g;
			$(this).val($(this).val().replace(nonNumReg, ''));
		});
		$('input[type="tel"]').on('input', function() {
			const nonNumReg = /[^0-9]/g;
			$(this).val($(this).val().replace(nonNumReg, ''));
		});
	},

	/**
	 * @description Show or hide fields based on the selected radio button option
	 */
	handleConditionalFields: function() {
		const requestOptions = document.querySelectorAll('.js-request-options');
		const hideForEmailRequests = document.querySelectorAll('.js-hide-for-email-requests');

		if (!requestOptions.length || !hideForEmailRequests.length) return;

		function toggleFields() {
			const selectedOption = document.querySelector('input[name="request-options"]:checked')?.value;

			// Reset visibility of all conditional fields
			hideForEmailRequests.forEach(el => {
				el.style.display = 'none'; // reset
			});

			// Show only if phone is selected
			if (selectedOption === 'Request a phone call') {
				hideForEmailRequests.forEach(el => {
					el.style.display = 'block';
				});
			}
		}

		// Run the function on page load to set the correct initial state
		toggleFields();

		// Add event listeners to the radio buttons to trigger the function when the selection changes
		requestOptions.forEach(option => {
			option.addEventListener('change', toggleFields);
		});
	}
};

export default FormHelpers;
